import React from 'react';

import { AuthContext, type AuthContextType } from '@client/context/AuthContext';

export const useAuth = (): AuthContextType => {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
